import { Tuple } from '@cgs/wge';
import { ViewInfo } from './view_info';

export const T_IViewInfoProvider = Symbol('IViewInfoProvider');
export interface IViewInfoProvider {
  getViewInfos(): Array<Tuple<symbol, ViewInfo>>;
}
